import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { getAllProductType } from '../../../../services/api/apiSku'
import {Select} from "antd"

class FilterSku extends Component {
    state = {
        types: [],
        error: ''
    }

    componentDidMount() {
        this._fetchListSku()
    }

    _fetchListSku = async () => {
        try {
            const payload = {
                is_deleted: false,
            }

            const {data: response} = await getAllProductType(payload)

            const {success, data, message} = response

            if (!success) {
                return this.setState({
                    error: message
                })
            }

            if(data.length > 0) {

                const listTypes = data.map(itemProduct => {
                    const option = {
                        value: itemProduct.sku,
                        name: itemProduct.sku
                    }
                    return option
                })
                
                this.setState({
                    types: listTypes
                })
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err.message
            })
        }
    }

    _handleChangeSku = (value) => {
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                sku: value
            })
        }
    }

    render() {
        // const {filters} = this.props
        // const {sku} = filters

        const {types} = this.state

        return (
            <div className="FilterSku mb-3 mr-3">
                <label className='font-weight-bold d-block'>SKU</label>
                <Select
                    mode="multiple"
                    allowClear
                    style={{
                        width: 250,
                    }}
                    placeholder="Chọn SKU"
                    onChange={this._handleChangeSku}
                    options={types}
                    showArrow
                />
            </div>
        )
    }
}

FilterSku.propTypes = {
    sku: PropTypes.string,
    onChangeFilter: PropTypes.func,
}

export default FilterSku